import { getSendbirdUserInfo } from '@apis/api/chat';
import { registerPushToken, TokenType, unregisterPushToken } from '@apis/api/user';
import { useUserInfoQuery } from '@apis/query/user';
import { registerFCMToSendbird, withSendbird } from '@asset/function/chat';
import { getDeviceToken } from '@asset/function/notification';
import { useChatPopupStore, useChatStore, useNotificationStore } from '@store/chat';
import { Button } from '@components/amc/Button';
import { cn } from '@/lib/utils';
import { IconMessage2 } from '@tabler/icons-react';
import { FCM_SERVICE_WORKER_SCOPE_SCRIPT_URL } from 'constants/chat';
import _ from 'lodash';
import { useQuery } from 'react-query';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const GnbChatButton = ({
  iconColor = 'hsl(var(--nav-accent-foreground))',
  darkMode = false
}) => {
  const {
    data: user
  } = useUserInfoQuery();
  const {
    unreadCount
  } = useChatStore();
  const {
    isChatPopupOpen,
    setIsChatPopupOpen
  } = useChatPopupStore();
  const {
    setNotificationPermission
  } = useNotificationStore();
  const {
    data: sendbirdUserInfo
  } = useQuery(['GET_SENDBIRD_USER_INFO', user?.userId], () => getSendbirdUserInfo(user?.userId), {
    enabled: !_.isNil(user?.userId)
  });
  const sendbirdUserId = sendbirdUserInfo?.userId;
  const sendbirdAccessToken = sendbirdUserInfo?.accessToken;
  return /*#__PURE__*/_jsx(Button, {
    variant: "Ghost",
    size: "Medium",
    className: cn(darkMode && 'hover:!bg-zinc-700 active:!bg-zinc-700', isChatPopupOpen && (darkMode ? '!bg-transparent' : '!bg-muted')),
    onClick: async () => {
      setIsChatPopupOpen(!isChatPopupOpen);
      if (!('Notification' in window)) {
        return;
      }
      if (Notification.permission === 'granted') {
        setNotificationPermission(Notification.permission);
        return;
      }
      const permission = await Notification.requestPermission();
      setNotificationPermission(permission);
      if (permission !== 'granted') {
        console.warn('Notification not permitted.');
        return;
      }
      const currentToken = await getDeviceToken();
      if (currentToken) {
        await unregisterPushToken(user.userId);
        registerPushToken(user.userId, TokenType.FCM, currentToken);
        withSendbird(sendbirdUserId, sendbirdAccessToken, sb => registerFCMToSendbird(sb, currentToken));
      }
      navigator.serviceWorker.getRegistration(FCM_SERVICE_WORKER_SCOPE_SCRIPT_URL).then(registration => {
        registration.showNotification('알림', {
          body: '알림이 허용되었습니다.',
          icon: '/common/logo/amc.png'
        });
      });
    },
    icon: /*#__PURE__*/_jsxs("div", {
      className: "relative",
      children: [/*#__PURE__*/_jsx(IconMessage2, {
        size: 24,
        color: iconColor
      }), unreadCount > 0 && /*#__PURE__*/_jsx("div", {
        className: "w-[0.375rem] h-[0.375rem] bg-red-500 rounded-full absolute top-0 right-0"
      })]
    })
  });
};
export default GnbChatButton;